import { useSessionStore } from "@/stores/session.store";

import { publicClient } from "./public-client";

export type { RequestOptions } from "./public-client";

export const authenticatedClient = publicClient.extend({
  context: {
    authentication: "session",
  },
  hooks: {
    init: [
      (options) => {
        const sessionSignal = useSessionStore().currentSessionSignal();

        options.signal = options.signal
          ? AbortSignal.any([options.signal, sessionSignal])
          : sessionSignal;
      },
    ],
    beforeRequest: [
      ({ request }) => {
        const { authToken } = useSessionStore();

        if (authToken) {
          request.headers.set("X-Auth-Token", authToken);
        }
      },
    ],
  },
});
